/**
 * YADA Site Constants
 * Centralized data for static site info
 * Translatable copy is stored as i18n keys (resolved via t()).
 */

export const SITE = {
  brand: {
    full: '青年耀進發展協會',
    short: 'YADA',
    english: 'Youth Advancement and Development Association',
    // Legal name (registered company) — use in copyright / official contexts.
    legalFull: '青年耀進發展協會有限公司',
    legalEnglish: 'Youth Advancement and Development Association Company Limited',
    tagline: '讓每一次肯定，都成為孩子心裡的一顆種子。',
  },
  contact: {
    whatsapp: {
      display: '+852 6887 6400',
      link: 'https://wa.me/85268876400',
    },
    email: {
      display: 'info@yada.hk',
      link: 'mailto:info@yada.hk',
    },
    website: {
      display: 'www.yada.hk',
      link: 'https://www.yada.hk',
    },
    address: {
      display: 'Hong Kong',
      link: 'https://maps.google.com/?q=Hong+Kong',
    },
  },
  /**
   * Social profiles. Same `{ display, link }` shape as `contact` above, so a
   * footer row can be rendered exactly like the contact rows.
   *
   * The Facebook page is a vanity URL — the `www.` is part of the Facebook
   * path, not a typo: facebook.com/www.yada.hk. `handle` is the readable
   * form for surfaces that show the address (the /contact card), mirroring
   * the Website card's "www.yada.hk" line.
   *
   * `display` is the brand name, so it is identical in every locale and
   * needs no translation.
   */
  social: {
    facebook: {
      display: 'Facebook',
      handle: 'facebook.com/www.yada.hk',
      link: 'https://www.facebook.com/www.yada.hk',
    },
  },
  stats: [
    { value: '3', labelKey: 'products' },
    { value: '5+', labelKey: 'years' },
    { value: '10+', labelKey: 'schools' },
    { value: '100%', labelKey: 'privacy' },
  ],
  processSteps: [
    {
      step: 'before',
      titleKey: 'site.process.before.title',
      descriptionKey: 'site.process.before.description',
      icon: 'search',
    },
    {
      step: 'during',
      titleKey: 'site.process.during.title',
      descriptionKey: 'site.process.during.description',
      icon: 'tool',
    },
    {
      step: 'after',
      titleKey: 'site.process.after.title',
      descriptionKey: 'site.process.after.description',
      icon: 'check',
    },
  ],
  values: [
    {
      id: 'student',
      titleKey: 'site.values.student.title',
      titleEn: 'Student-First',
      icon: 'users',
      descriptionKey: 'site.values.student.description',
    },
    {
      id: 'privacy',
      titleKey: 'site.values.privacy.title',
      titleEn: 'Data Privacy',
      icon: 'shield',
      descriptionKey: 'site.values.privacy.description',
    },
    {
      id: 'teacher',
      titleKey: 'site.values.teacher.title',
      titleEn: 'Teacher Empowerment',
      icon: 'sparkles',
      descriptionKey: 'site.values.teacher.description',
    },
    {
      id: 'partnership',
      titleKey: 'site.values.partnership.title',
      titleEn: 'Long-term Partnership',
      icon: 'handshake',
      descriptionKey: 'site.values.partnership.description',
    },
  ],
}